module.exports = __webpack_public_path__ + "static/media/yiyuan10.300dfc38.png";